import React, { useContext, useEffect } from "react"
import { ModalContext } from "../../Context/ModalContext"
import * as imageModalStyles from "./ImageModal.module.scss"

const ImageModal = () => {
  const { isModalVisible, hideModal } = useContext(ModalContext)

  const cutoffDate = new Date("2025-03-08T01:00:00Z")

  const isBeforeCutoff = new Date() < cutoffDate

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      hideModal()
    }
  }

  if (!isModalVisible || !isBeforeCutoff) return null

  return (
    <div className={imageModalStyles.modalOverlay} onClick={handleOverlayClick}>
      <div className={imageModalStyles.modalContent}>
        <img
          src={require("../../images/index/francisktrunk2025.jpg").default}
          alt="Press Eyewear Trunk show at Center City Feb 28th."
          className={imageModalStyles.modalImage}
        />
        <button
          onClick={hideModal}
          className={imageModalStyles.modalCloseButton}
        >
          Close
        </button>
      </div>
    </div>
  )
}

export default ImageModal
